import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import { oidcSettings } from '@/config/oidc'
// import store from '@/store'

const oidc = vuexOidcCreateStoreModule(
  oidcSettings,
  {
    namespaced: true,
    dispatchEventsOnWindow: true,
    publicRoutePaths: ['/oidc-callback', '/logout', '/training', '/course', '/course/', '/exam'],
  },
  {
    //userLoaded: (user) => console.log('OIDC user is loaded:', user),
    userLoaded: (user) => {
      console.log('OIDC user is loaded:', user)

      //store.dispatch('user/setUserInfo', user.profile)
      //store.dispatch('user/getInfo')

      // var role = user.profile['role']
      // console.log(role.includes('Student'));
      // if (!role.includes('Student')) {
      //   //console.log('权限不足');
      //   //console.log(user.profile);
      //   window.location.href = "https://boyuanclass.admin.gzbytech.com";
      // }
    }, 
    userUnloaded: () => console.log('OIDC user is unloaded'),
    accessTokenExpiring: () => console.log('Access token will expire'),
    accessTokenExpired: () => console.log('Access token did expire'),
    silentRenewError: () => console.log('OIDC user is unloaded'),
    userSignedOut: () => {
      console.log('OIDC user is signed out')

      //store.dispatch('oidc/signOutOidc')
    },
    oidcError: (payload) => console.log('OIDC error', payload),
    automaticSilentRenewError: (payload) => console.log('OIDC automaticSilentRenewError', payload)
  }
)

export default oidc
